export enum CheckAction {
  CheckIn = 'checkin',
  CheckOut = 'checkout',
}

export enum CheckEntity {
  Event = 'events',
  Session = 'sessions',
}

export enum CheckType {
  Manual,
  Scanner,
}

export enum ErrorCode {
  KioskModeNotPermitted = 'kiosk_mode_not_permitted',
  PersonNotFound = 'person_not_found',
  NotAuthorized = 'user_not_authenticated',
}
